import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../core/services/contact-us.service';

@Component({
  selector: 'app-req-commission',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './req-commission.component.html',
  styleUrl: './req-commission.component.css'
})
export class ReqCommissionComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  form: FormGroup;

  constructor(private fb: FormBuilder, private contactUsService: ContactUsService) {}

  get labels() { return this.contactUsService.commonLabels; }
  get messages() { return this.contactUsService.messageLabels; }

  ngOnInit() {
    this.form = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(20)]],
      region: ['US']
    });

    this.formReady.emit(this.form);
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }
}
